<div class="flex h-full w-full min-w-0 flex-col sm:inset-0">
  <mat-drawer-container class="flex min-h-0 flex-1 sm:h-full">
    <!-- Drawer -->
    <mat-drawer
      [autoFocus]="false"
      [mode]="drawerMode()"
      [opened]="drawerOpened()"
      [position]="'end'"
      class="sm:w-96"
      #drawer
    >
      <div class="w-full">
        <!-- Header -->
        <div class="flex items-center justify-between bg-gray-1 p-8 pr-6 sm:py-8">
          <!-- Title -->
          <div class="text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>
          <!-- Close button -->
          <div class="lg:hidden">
            <button (click)="drawer.close()" mat-icon-button>
              <mat-icon class="h-6 w-6 text-4xl">close</mat-icon>
            </button>
          </div>
        </div>
        <!-- Panel links -->
        <div class="flex flex-col divide-y border-t border-b">
          @for (panel of panels(); track panel.id) {
            <button
              [ngClass]="{
                'hover:bg-gray-1': !currentPanel() || currentPanel()?.id !== panel.id,
                'bg-primary-3': currentPanel() && currentPanel()?.id === panel.id,
              }"
              (click)="goToPanel(panel)"
              (keydown)="(null)"
              class="flex cursor-pointer bg-gray-3 px-6 py-4"
            >
              <mat-icon
                [ngClass]="{
                  'text-hint': !currentPanel() || currentPanel()?.id !== panel.id,
                  'text-primary': currentPanel() && currentPanel()?.id === panel.id,
                }"
                class="h-8 w-8 self-center text-4xl"
              >
                {{ panel.icon }}
              </mat-icon>
              <div class="m-auto ml-3 flex flex-col">
                <div
                  [ngClass]="{
                    'text-primary': currentPanel() && currentPanel()?.id === panel.id,
                    'font-bold': currentPanel() && currentPanel()?.id === panel.id,
                  }"
                  class="flex"
                >
                  {{ panel.title }}
                </div>
                @if (panel.description) {
                  <div class="text-secondary mt-0.5 text-justify">
                    {{ panel.description }}
                  </div>
                }
              </div>
            </button>
          }
        </div>
      </div>
    </mat-drawer>

    <!-- Drawer content -->
    <mat-drawer-content class="flex flex-col min-w-0 whitespace-normal">
      <!-- Main -->
      <div class="mx-auto w-full max-w-3xl min-w-0 flex-auto px-6 py-12 md:px-8 lg:px-12 whitespace-normal">
        <!-- Panel header -->
        <div class="flex w-full justify-between">
          <!-- Panel title -->
          <div class="ml-2 text-3xl leading-none font-bold tracking-tight lg:ml-0"></div>

          <!-- Drawer toggle -->
          <button (click)="drawer.toggle()" class="-ml-2 lg:hidden" mat-icon-button>
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <ng-content></ng-content>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
